<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          config-module="231512"
          :reset="true"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <!--统计-->
            <el-button :disabled="total <= 0" type="primary" @click="statistics_clickHandler()">{{ $t('SeaExport.Statistics') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            config-module="23151200"
            :grid-options="gridOptions"
            :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-params.sync="gridParams"
            :enable-col-resize="true"
            :enable-sorting="true"
            :check-main-record="false"
            :deselect-main-record="false"
            class="ag-theme-balham"
            style="width: 100%;"
            @gridReady="onGridReady"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="23151200"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="()=>{if(total>0){toQuery()}}"
          />
        </div>
      </div>
      <!-- 统计弹窗 -->
      <el-dialog
        v-if="statisticsDialog.visible"
        v-el-drag-dialog
        :visible.sync="statisticsDialog.visible"
        :title="$t('SeaExport.Statistics')"
        :width="$selectByLang('360px', '445px')"
        :close-on-click-modal="false"
      >
        <el-form :label-width="$selectByLang('85px', '170px')" label-position="left">
          <el-form-item :label="$t('SeaExport.Slaves')" class="custom">
            <el-input v-model="statisticsDialog.txtSlaves" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TotalTickets')" class="custom">
            <el-input v-model="statisticsDialog.txtCount" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerCount')" class="custom">
            <el-input v-model="statisticsDialog.txtCustomerCount" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item label="20＇" class="custom">
            <el-input v-model="statisticsDialog.txt20" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item label="40＇" class="custom">
            <el-input v-model="statisticsDialog.txt40" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item label="40HQ＇" class="custom">
            <el-input v-model="statisticsDialog.txt40hq" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item label="45＇" class="custom">
            <el-input v-model="statisticsDialog.txt45" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item label="TEU" class="custom">
            <el-input v-model="statisticsDialog.txtTeu" style="width:160px" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Weight2')" class="custom">
            <el-input v-model="statisticsDialog.txtWeight" style="width:160px" :disabled="true" />
            <span>KGS</span>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Cubage')" class="custom">
            <el-input v-model="statisticsDialog.txtCubage" style="width:160px" :disabled="true" />
            <span>CBM</span>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargedWeight')" class="custom">
            <el-input v-model="statisticsDialog.txtChargeWeight" style="width:160px" :disabled="true" />
            <span>M/T</span>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SpecifyAgentNumber')" class="custom">
            <el-input v-model="statisticsDialog.txtdesignationAgentNum" style="width:160px" :disabled="true" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="statisticsDialog.visible = false">{{ $t('SeaExport.Close') }}</el-button>
        </div>
      </el-dialog>

      <!-- 销售要求弹窗 -->
      <el-dialog
        v-if="salesRequireDialog.visible"
        v-el-drag-dialog
        :visible.sync="salesRequireDialog.visible"
        :title="$t('SeaExport.SalesRequire')"
        width="360px"
      >
        <el-input v-model="salesRequireDialog.salesRequire" type="textarea" :rows="15" :readonly="!salesRequireDialog.isEdit" />
        <div slot="footer">
          <el-button v-show="salesRequireDialog.isEdit" type="primary" @click="enterSalesRequire">{{ $t('SeaExport.Submission') }}</el-button>
          <el-button v-show="!salesRequireDialog.isEdit" @click="salesRequireDialog.visible = false">{{ $t('SeaExport.Close') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as LayersUtil from '@/class/cargo/model/utils/LayersUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { findMoreJobForSales2HW, updateSalesAndUserDefined } from '@/api/booking/job'
import { formatNumberToThousands } from '@/utils'
import { statisticsJobs } from '@/api/seaExport/seaExportJob'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import editIcon from '@/assets/edit_icon.net.png'
import viewIcon from '@/assets/view_icon.net.png'
import { DocumentManage } from '@/utils/commonUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'SalesQuery2Sale',
  components: { searchItem },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      checkJobTypeHasDiff: false, // 是否验证业务类型
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      total: 0,
      selectedJob: null,
      gridParams: {},
      documentManage: new DocumentManage(),
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        onRowClicked: this.onRowClicked,
        getRowStyle: (params) => {
          const row = params.data
          const colorType = Number(this.$store.state.settings.colorType) === 1
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
            Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
            JobUtils.isBlockJob(row)) {
            return { 'background': LayersUtil.STATE_BLOCKED.colorValue }
          } else {
            const jobState = String(row.jobState) || ''
            for (const stateColor of LayersUtil.COLOR_STATES) {
              if (jobState === stateColor.colorKey) {
                return { 'background': stateColor.colorValue }
              }
            }
          }
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [ // 显示列
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 150
        }, {
          headerName: 'SOP',
          field: 'sopState',
          colId: 'sopState',
          width: 150,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('SeaExport.Customer'),
          colId: 'customerId',
          field: 'customerId',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
            // return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          colId: 'customerTypeId',
          field: 'customerTypeId',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.isSignContract'),
          colId: 'bContract',
          field: 'bContract',
          valueFormatter: (params) => {
            if (!params.value) params.value = 0
            return ColumnUtils.loadContractsLabelFunc(parseInt(params.value))
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.SalesRequire'),
          colId: 'salesRequire',
          field: 'salesRequire',
          width: 150,
          noIgnoreCellRenderer: true,
          cellRenderer: params => {
            const icon = Number(params.data.jobState) === 0 ? editIcon : viewIcon
            const methodPath = this.documentManage.getPath('showSalesRequire')
            return `<span style="min-width: 50px;position: relative;">${params.value}</span><img src="${icon}" height="16" width="16" style="position: absolute; right: 0; top: 5px; cursor:pointer" onclick="${methodPath}('${params.data.key}')"/>`
          },
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          valueFormatter: (params) => {
            return ColumnUtils.getPortLabel('code', params.value, params.data, 'auto_7')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.TransitPort'),
          colId: 'transferPortCode',
          field: 'transferPortCode',
          valueFormatter: (params) => {
            return ColumnUtils.getPortLabel('code', params.value, params.data, 'auto_7')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          valueFormatter: (params) => {
            return ColumnUtils.getPortLabel('code', params.value, params.data, 'auto_7')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          field: 'ETD',
          colId: 'ETD',
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageActual',
          colId: 'cubageActual',
          valueFormatter: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightActual',
          colId: 'weightActual',
          valueFormatter: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityActual',
          colId: 'quantityActual',
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          field: 'chargeWeight',
          colId: 'chargeWeight',
          valueFormatter: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_csr')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          colId: 'cargoSalesId',
          field: 'cargoSalesId',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.SalesDepartment'),
          field: 'salesDepartment',
          colId: 'salesDepartment',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          colId: 'lob',
          valueFormatter: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          field: 'warehouseCmp',
          colId: 'warehouseCmp',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_10') : ''
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShutOut'),
          field: 'isShutOut',
          colId: 'isShutOut',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 150
        }
      ],
      rowData: [],
      gridApi: null,
      salesRequireDialog: { // 销售要求
        visible: false,
        salesRequire: '',
        isEdit: false,
        jobKey: ''
      },
      statisticsDialog: { // 统计
        visible: false,
        txtSlaves: 0,
        txtCount: 0,
        txtCustomerCount: 0,
        txt20: 0,
        txt40: 0,
        txt40hq: 0,
        txt45: 0,
        txtTeu: 0,
        txtWeight: 0.000,
        txtChargeWeight: 0.000,
        txtCubage: 0.000,
        txtdesignationAgentNum: 0
      }
    }
  },
  computed: { },
  created() { },
  beforeMount() {
    const context = this
    this.documentManage.set('showSalesRequire', function(jobKey) {
      context.showSalesRequire(jobKey)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 列表 销售要求
    showSalesRequire(jobKey) {
      this.salesRequireDialog.jobKey = jobKey
      const current = this.rowData.find(p => p.key === jobKey)
      this.salesRequireDialog.salesRequire = current.salesRequire || ''
      this.salesRequireDialog.isEdit = Number(current.jobState) === 0
      this.salesRequireDialog.visible = true
    },
    // 销售要求提交
    enterSalesRequire() {
      this.loading = getLoading()
      const current = this.rowData.find(p => p.key === this.salesRequireDialog.jobKey)
      updateSalesAndUserDefined({ salesRequire: this.salesRequireDialog.salesRequire, jobKey: current.key }).then(res => {
        current.salesRequire = this.salesRequireDialog.salesRequire || ''
        this.gridApi.refreshCells({ force: true })
        this.salesRequireDialog.visible = false
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.loading = getLoading()
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filter.conditions = data
        this.filter.pageNum = 1
      }
      // 操作公司
      if (!this.filter.conditions) this.filter.conditions = []
      if (!AdvancedSearchOption.hasField('OMS_JOB.OP_OFFICE', this.filter.conditions)) {
        this.filter.conditions.push(new AdvancedSearchOption(null, 'OMS_JOB.OP_OFFICE', this.$store.getters.currentOfficeId).formatObj2Json())
      }
      const requestBody = {
        otherMap: { saleCsr: 'sale' },
        conditions: this.filter.conditions,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      const colorType = Number(this.$store.state.settings.colorType) === 1
      if (colorType) {
        requestBody.requires = ['financeColor']
      }
      findMoreJobForSales2HW(requestBody).then(res => this.handleQueryData(res.data)).finally(() => {
        this.loading.close()
      })
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.loading = getLoading()
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      // 业务编号
      if (!this.filter.conditions) this.filter.conditions = []
      if (!AdvancedSearchOption.hasField('OMS_JOB.JOB_NO', this.filter.conditions)) {
        this.filter.conditions.push(new AdvancedSearchOption(null, 'OMS_JOB.JOB_NO', this.filter.jobNo).formatObj2Json())
      }
      // 操作公司
      if (!AdvancedSearchOption.hasField('OMS_JOB.OP_OFFICE', this.filter.conditions)) {
        this.filter.conditions.push(new AdvancedSearchOption(null, 'OMS_JOB.OP_OFFICE', this.$store.getters.currentOfficeId).formatObj2Json())
      }
      const requestBody = {
        conditions: this.filter.conditions,
        otherMap: { saleCsr: 'sale' },
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize
      }
      const colorType = Number(this.$store.state.settings.colorType) === 1
      if (colorType) {
        requestBody.requires = ['financeColor']
      }
      findMoreJobForSales2HW(requestBody).then(res => this.handleQueryData(res.data)).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      // 核销状态
      this.rowData = res.results.list || []
      this.filter.pageNum = res.results.pageNum
      this.filter.pageSize = res.results.pageSize
      this.total = Number(res.results.total)
      this.gridApi.clearFocusedCell()
    },
    // 选中行数
    readSelectedRows() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      return rows
    },
    // 统计
    statistics_clickHandler() {
      this.statisticsClean()
      const rows = this.readSelectedRows()
      const jobKeys = []
      const designationAgents = []
      const customers = []
      let weight = 0
      let chargeWeight = 0
      let cubage = 0
      let slavesCount = 0
      let count = 0
      for (const job of rows) {
        count++
        jobKeys.push(job.key)

        weight += isNaN(job.weightActual) ? 0 : job.weightActual
        cubage += isNaN(job.cubageActual) ? 0 : job.cubageActual
        chargeWeight += isNaN(job.chargeWeight) ? 0 : job.chargeWeight
        slavesCount += 1

        if (!customers.includes(job.customerId) && !job.masterFlag) {
          customers.push(job.customerId)
        }
        if (!designationAgents.includes(job.designationAgent) && job.designationAgent !== 0) {
          designationAgents.push(job.designationAgent)
        }
      }
      this.statisticsDialog.txtSlaves = slavesCount.toString()
      this.statisticsDialog.txtCount = count.toString()
      this.statisticsDialog.txtCustomerCount = customers.length.toString()
      this.statisticsDialog.txtWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(weight), 3)
      this.statisticsDialog.txtCubage = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(cubage), 3)
      this.statisticsDialog.txtChargeWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(chargeWeight), 3)
      this.statisticsDialog.txtdesignationAgentNum = designationAgents.length.toString()
      statisticsJobs({ jobKeys: jobKeys, lob: 'all' }).then(res => this.statisticsJobsResult(res.data))
    },
    // 统计结果
    statisticsJobsResult(res) {
      if (!res) return
      this.statisticsDialog.txt20 = res.b20
      this.statisticsDialog.txt40 = res.b40
      this.statisticsDialog.txt40hq = res.b40h
      this.statisticsDialog.txt45 = res.b45
      this.statisticsDialog.txtTeu = res.teu
      this.statisticsDialog.visible = true
    },
    // 统计完成 清空对象
    statisticsClean() {
      if (!this.statisticsDialog) return
      for (const key in this.statisticsDialog) {
        this.statisticsDialog[key] = ''
      }
    },
    onGridReady(p) {
      // console.log('gridReady', p)
      this.gridApi = p.api
    }
  }
}
</script>

<style lang="scss">
</style>
